import {Link} from 'react-router-dom';
import Sidebar from './sidebar';
import { CheckCircle, Plus } from 'react-feather';
import React, { useState,useEffect,useRef } from 'react';
import api from "../api";
function SellerWithdraw(){
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const token = localStorage.getItem("access_token");
    const [OrderItems,setOrderItems]=useState([]);
    const [selectedPaymentMode, setSelectedPaymentMode] = useState('');
    const [PayDiv1,setPayDiv1]=useState(false);
    const [PayDiv2,setPayDiv2]=useState(false);
    const [PayDiv3,setPayDiv3]=useState(false);
    const [PayDiv4,setPayDiv4]=useState(false);
    const [showSuccess,setShowSuccess]=useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [pymtFormData, setPymtFormData]=useState({
        "bank_code":'',
        "pay_mode_desc":'',
        "pay_mode_desc_paybill":'',
        "acc_no":'',
    });
    const [pymtFormData0, setPymtFormData0]=useState({
        "bank_code":'',
        "pay_mode_desc":'',
        "pay_mode_desc_paybill":'',
        "acc_no":'',
    });
    const [selectedBankIntasend, setSelectedBankIntasend] = useState(0);
    const [selectedBankIntasendCode, setSelectedBankIntasendCode] = useState(0);
    const inputRef = useRef(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [VendorCurrency,setVendorCurrency]=useState([]);     
    const [strbal, setBalance] = useState('');
    const [strdev, setDeviation] = useState('');
    const [amount, setAmount] = useState('');
    const [pass, setPass] = useState('');
    const [loadingWithdraw, setLoadingWithdraw] = useState(false);
    const [message, setMessage] = useState(null);
    const [message0, setMessage0] = useState(null);
    const [csrfToken, setCsrfToken] = useState("");
    const [banks, setBanks] = useState([]);
    const [withdrawals, setWithdrawals] = useState([]);

    const banksIntasend = [
        { bank_name: "KCB", bank_code: "1", bank_paybill: "18743" },
        { bank_name: "Standard Charted Bank KE", bank_code: "2", bank_paybill: "29871" },
        { bank_name: "Barclays Bank", bank_code: "3", bank_paybill: "64527" },
        { bank_name: "NCBA", bank_code: "7", bank_paybill: "83291" },
        { bank_name: "Prime Bank", bank_code: "10", bank_paybill: "10392" },
        { bank_name: "Cooperative Bank", bank_code: "11", bank_paybill: "59837" },
        { bank_name: "National Bank", bank_code: "12", bank_paybill: "71036" },
        { bank_name: "Citibank", bank_code: "16", bank_paybill: "45120" },
        { bank_name: "Habib Bank AG Zurich", bank_code: "17", bank_paybill: "26480" },
        { bank_name: "Middle East Bank", bank_code: "18", bank_paybill: "90384" },
        { bank_name: "Bank of Africa", bank_code: "19", bank_paybill: "34751" },
        { bank_name: "Consolidated Bank", bank_code: "23", bank_paybill: "53214" },
        { bank_name: "Credit Bank Ltd", bank_code: "25", bank_paybill: "78092" },
        { bank_name: "Stanbic Bank", bank_code: "31", bank_paybill: "61980" },
        { bank_name: "ABC Bank", bank_code: "35", bank_paybill: "47391" },
        { bank_name: "Spire Bank", bank_code: "49", bank_paybill: "31589" },
        { bank_name: "Paramount Universal Bank", bank_code: "50", bank_paybill: "82640" },
        { bank_name: "Jamii Bora Bank", bank_code: "51", bank_paybill: "19842" },
        { bank_name: "Guaranty Bank", bank_code: "53", bank_paybill: "78436" },
        { bank_name: "Victoria Commercial Bank", bank_code: "54", bank_paybill: "25017" },
        { bank_name: "Guardian Bank", bank_code: "55", bank_paybill: "69304" },
        { bank_name: "I&M Bank", bank_code: "57", bank_paybill: "81054" },
        { bank_name: "DTB", bank_code: "63", bank_paybill: "32096" },
        { bank_name: "Sidian Bank", bank_code: "66", bank_paybill: "45903" },
        { bank_name: "Equity Bank", bank_code: "68", bank_paybill: "97524" },
        { bank_name: "Family Bank", bank_code: "70", bank_paybill: "24681" },
        { bank_name: "Gulf African Bank", bank_code: "72", bank_paybill: "13478" },
        { bank_name: "First Community Bank", bank_code: "74", bank_paybill: "50927" },
        { bank_name: "KWFT Bank", bank_code: "78", bank_paybill: "64238" },
        { bank_name: "Housing Finance Company Limited (HFCK)", bank_code: "61", bank_paybill: "38745" },
        { bank_name: "Mayfair Bank Limited", bank_code: "65", bank_paybill: "27460" }
    ];


    useEffect(()=>{
        fetchCsrf();
        fetchData();
        fetchData0();
        fetchDataTransactions();
        //fetchBanks();
    },[]);
    
    const fetchBanks = async () => {
        try {
            const response = await fetch('https://api.paystack.co/bank', {
            method: 'GET',
            headers: {
            Authorization: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
            'Content-Type': 'application/json',
            },
            });
            if (!response.ok) {
            throw new Error(`Error: ${response.status}`);
            }
    

            const result = await response.json();
            const filtered = result.data.filter((bank) => bank.country === 'Kenya');
            setBanks(filtered);
            //console.log(banks);

        } catch (error) {
            //console.error('Failed to fetch bank list:', error);
        }
    };
    
    const bankinputHandler = (e) => {
        const fullValue = e.target.value; // e.g. "National Bank - 12"
        const parts = fullValue.split(" - ");
        const bankName = parts[0];
        const bankCode = parts[1];

        setSelectedBankIntasend(bankName);         // "National Bank"
        setSelectedBankIntasendCode(bankCode);      // "12"
    };
  
    const fetchCsrf = async () => {
            api.get(`${baseUrl}/get-csrf-token/`, { withCredentials: true })
            .then(response => {
                setCsrfToken(response.data.csrfToken);
            })
            .catch();
    }
    const fetchData = async () => {
        try {
            const response = await api.get("/vendor/", {
            headers: {
                Authorization: `Bearer ${token})}`,
            },
            });
            setSelectedPaymentMode(response.data.pay_mode);
            setPymtFormData0({                
                    "bank_code":selectedBankIntasendCode,
                    "pay_mode_desc":response.data.pay_mode_desc,
                    "pay_mode_desc_paybill":response.data.pay_mode_desc_paybill,
                    "acc_no":response.data.acc_no,
            });

        } catch (error) {
            //console.error("Error fetching products:", err.toJSON());
        }
    }
    const fetchData0 = async () => {
        try {
          const response = await api.get(baseUrl+"/vendor-orderitems/", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setOrderItems(response.data.order_items);
          setBalance(response.data.vendor_balance);
          setDeviation(response.data.weekly_deviation);
          setVendorCurrency(response.data.currency);
        } catch (err) {
          //console.error("Error fetching products:", err);
          setError("Failed to fetch products. Please try again.");
        }finally {
            setLoading(false);
        }
    };
    const fetchDataTransactions = async () => {
        try {
          const response = await api.get(baseUrl+"/vendor/withdrawals/", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setWithdrawals(response.data.withdrawals);
        } catch (err) {
          //console.error("Error fetching products:", err);
          setError("Failed to fetch products. Please try again.");
        }finally {
            setLoading(false);
        }
    };

    const handleRadioChange = async (event) => {
        const newPaymentMode = event.target.value;
        setSelectedPaymentMode(newPaymentMode);

        try {
            const response = await api.patch("/vendor/", 
                { pay_mode: newPaymentMode }, // Data payload
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setErrorMsg('');
            setSuccessMsg('Payment mode updated successfully!');
        } catch (error) {
            setErrorMsg('Failed to update payment mode. Please try again.');
            setSuccessMsg('');
        }

    };
    const inputHandler =(event) => {
        setPymtFormData({
            ...pymtFormData,
            [event.target.name]:event.target.value
        })
    };
    const submitHandler = async (event) => {
        var paybill=0;
        if(pymtFormData.pay_mode_desc == ""){
            setPayDiv1(true);setPayDiv2(false);setPayDiv3(false);setPayDiv4(false);
        }else if(selectedBankIntasend.length < 6 && pymtFormData.pay_mode_desc == "Bank"){
            setPayDiv1(false);setPayDiv2(true);setPayDiv3(false);setPayDiv4(false);
        }else if(pymtFormData.acc_no.length < 12){
            setPayDiv1(false);setPayDiv2(false);setPayDiv3(true);setPayDiv4(false);
        }else{
            if(pymtFormData.pay_mode_desc=="Bank"){paybill=selectedBankIntasend;}
            const formData=new FormData();
            formData.append('bank_code',selectedBankIntasendCode);
            formData.append('pay_mode_desc',pymtFormData.pay_mode_desc);
            formData.append('pay_mode_desc_paybill',paybill);
            formData.append('acc_no',pymtFormData.acc_no);

            try {
                const response = await api.patch("/vendor/", 
                    formData, // Data payload
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                    setPayDiv1(false);setPayDiv2(false);setPayDiv3(false);setPayDiv4(true);
                    setPymtFormData0({
                        "pay_mode_desc":response.data.pay_mode_desc,
                        "pay_mode_desc_paybill":response.data.pay_mode_desc_paybill,
                        "acc_no":response.data.acc_no,
                   });
                   setErrorMsg('');
                   setSuccessMsg('Payment details updated successfully!');
            } catch (error) {
                setErrorMsg('Failed to update payment mode. Please try again.');
                setSuccessMsg('');
            }

        }
    };
    const getVendorCurrency = () => {
        return localStorage.getItem("VendorCurrency");
    };
    function formatDate(dateString) {
        const date = new Date(dateString);
        const month = date.toLocaleDateString('en-US', { month: 'short' }); // "Nov"
        const day = date.getDate(); // 1
        const time = date.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        }).toLowerCase(); // "11:01 pm"
    
        return `${month} ${day}, ${time.replace(':', '.')}`; // "Nov 01 11.01pm"
    }
    // Filter quotations based on the search term
    const filteredResults = withdrawals.filter((withdrawal) => {
        const search = searchTerm.toLowerCase();
        return (
            withdrawal.reference.toLowerCase().includes(search) ||
            withdrawal.status.toLowerCase().includes(search)
        );
    });

    const handleWithdraw = async () => {
        setMessage0('');
        setMessage('');
        if (!amount || isNaN(amount) || parseFloat(amount) <= 0) {
          setMessage0('Kindly enter a valid amount.');
          return;
        }
        setLoadingWithdraw(true);    
        try {
            const formData = new FormData();
            formData.append('amount', amount);
            formData.append('password', pass);

            const response = await api.post(baseUrl+'/withdraw/', formData, {
            headers: { Authorization: `Bearer ${token}`, 'X-CSRFToken': csrfToken, }
            });
            
            if(response.data.bool === true ){setShowSuccess(true);}else{setMessage0(response.data.msg);}
        } catch (err) {
          setMessage0('Oops! Confirm your credentials and network connection, then try again.');
        } finally {
          setLoadingWithdraw(false);
        }
    };
    setTimeout(() => {
        setErrorMsg('');
        setSuccessMsg('');
    }, 5000);
    const handleProceedClick = () => {
        if (inputRef.current) {
          inputRef.current.classList.add('outline-highlight');
          setTimeout(() => {
            inputRef.current.classList.remove('outline-highlight');
          }, 2000);
        }
    };


    return (
        <section className="container mtopcon dashb">         
            <div className="row">
                
                    <div className="col-12 col-lg-2 dash-min mb-3">
                        <div className="nav-left-sidebar sidebar-dark pc">
                            <div className="slimScrollDiv" ><div className="menu-list" >
                                <nav className="navbar navbar-expand-lg navbar-light nav-l-con">
                                    <a className="d-xl-none d-lg-none" href="#"></a>
                                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                        <span className="navbar-toggler-icon"></span>
                                    </button>
                                    <div className="collapse navbar-collapse" id="navbarNav">
                                        <Sidebar/>
                                    </div>
                                </nav>
                            </div><div className="slimScrollBar"></div><div className="slimScrollRail"></div></div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-10 dash-max">
                        <div className="row mb-3 ph-header-con">
                            <div className="col-7 pt-2"><h6 className="pageheader-title mb-3">Manage Finances </h6></div>
                        </div>
                        
                        <div className="row mb-3">
                            <div className="col-12 col-lg-4">
                            <div className="card shadow-sm border border-secondary border-opacity-10">
                                        <div className="card-body pymtdiv"> 
                                                <div className="accordion accordion-flush" id="accordionFlushExample">
                                                    <div className="accordion-item">
                                                        <h2 className="accordion-header">
                                                        <button className="accordion-button collapsed p-0" type="button" data-bs-toggle="collapse" data-bs-target="#flush-coll2" aria-expanded="false" aria-controls="flush-coll2">                                                            
                                                            <label htmlFor="lnm" className="form-label mb-0 font9"><b>Payment Method:</b> {selectedPaymentMode === '0' && <>Manual</>}{selectedPaymentMode === '1' && <>Automated</> }</label>
                                                        </button>
                                                        </h2>
                                                        <div id="flush-coll2" className="accordion-collapse collapse paymethod" data-bs-parent="#accordionFlushExample">
                                                            <div className="accordion-body">
                                                                {successMsg && <p className="text-success mt-4 text-center"><b>{successMsg}</b></p> } 
                                                                {errorMsg && <p className="text-danger mt-4 text-center"><b>{errorMsg}</b></p> }   
                                                            <div className="row pt-4">
                                                                <div className="col-12 col-lg-12">
                                                                    <div className="card border-top-secondary btp1">
                                                                        <div className="card-body">
                                                                            <h5><b>Manual Payment</b></h5>
                                                                                <p className="font9">Customers pay you directly via their SIM Toolkit or banking app then you confirm and update orders manually.</p>
                                                                            <div className="metric-value d-inline-block">
                                                                                <input
                                                                                    type="radio"
                                                                                    value="0"
                                                                                    checked={selectedPaymentMode === '0'}
                                                                                    onChange={handleRadioChange}
                                                                                />
                                                                            </div>
                                                                            <div className="metric-label d-inline-block float-right text-success font-weight-bold">
                                                                                <span className="icon-circle-small icon-box-xs text-success bg-success-light"></span><span className="ml-1">0%</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-lg-12">
                                                                    <div className="card border-top-secondary btp2">
                                                                        <div className="card-body">
                                                                            <h5><b>Automated Payment</b></h5>
                                                                                <p className="font9">Customers are auto-prompted to pay, and you receive the money instantly. Orders, stock, and customer loyalty is updated instantly.</p>
                                                                            <div className="metric-value d-inline-block">
                                                                                <input
                                                                                    type="radio"
                                                                                    value="1"
                                                                                    checked={selectedPaymentMode === '1'}
                                                                                    onChange={handleRadioChange}
                                                                                />
                                                                            </div>
                                                                            <div className="metric-label d-inline-block float-right text-success font-weight-bold">
                                                                                <span className="icon-circle-small icon-box-xs text-success bg-success-light"></span><span className="ml-1">3% Mpesa, 5% Cards</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                        </div>
                                    </div>
                                    <div className="card shadow-sm border border-secondary border-opacity-10">
                                    {pymtFormData0.acc_no != '0' && <>
                                        <div className="card-header font9">
                                            <div className='row p-0 m-0'>
                                                <p className='pl-3 m-0 col-12'><b>Send Money </b></p>
                                            </div>
                                        </div> 
                                        <div className="card-body pt-1"> 
                                                <div className="row ordbgrw pb-1">
                                                    <div className="col-9 ord-sz1 pt-2"><font className="grey-text">Available Balance</font><br/> <h3>{getVendorCurrency()}. {Intl.NumberFormat().format(strbal)}</h3></div>
                                                    <div className="col-3 ord-sz1 pt-2"><font className="grey-text">Growth</font><br/>                                                         
                                                        {strdev >= '0' && <><font className='text-success'>{strdev}%</font></>}
                                                        {strdev < '0' && <><font className='text-danger'>{strdev}%</font></>}
                                                    </div>
                                                </div> 
                                                <div className="mb-3">      
                                                        <label htmlFor="lnm" className="form-label mb-0"><b>Payout to</b></label>
                                                        <div className="grey-text font9 mb-2">Select preferred payment account</div>
                                                        <select className="form-control font9 ht40" >
                                                            <option value={pymtFormData0.acc_no}>{pymtFormData0.pay_mode_desc} - {pymtFormData0.acc_no}</option>
                                                        </select>
                                                        <div className="input-group amount-div mt-3" ref={inputRef} >
                                                            <span className="input-group-text font9">{getVendorCurrency()}</span>
                                                            <input type="number" className="form-control font9 ht40" placeholder="Amount" value={amount}onChange={(e) => setAmount(e.target.value)}/>
                                                        </div>
                                                        {parseFloat(amount) > 0 ? (
                                                            <button
                                                            type="button"
                                                            className="col-12 btn btn-primary mt-4"
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#withdrw"
                                                            >
                                                            Proceed
                                                            </button>
                                                        ) : (
                                                            <button
                                                            type="button"
                                                            className="col-12 btn btn-primary mt-4"
                                                            onClick={handleProceedClick}
                                                            >
                                                            Proceed
                                                            </button>
                                                        )}
                                                    
                                                    <button type="button" className="col-12 btn btn-light mt-4 addpymt" data-bs-toggle="modal" data-bs-target="#addaccount"><Plus /> Update Payment Details</button>
                                                </div>              

                                                <div className="accordion accordion-flush mt-40 bg-white br-10" id="accordionFlushExample1">
                                                    <div className="accordion-item">
                                                        <h6 className="accordion-header">
                                                        <button className="accordion-button collapsed grey-text p-0 font9" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne1" aria-expanded="false" aria-controls="flush-collapseOne1">
                                                            View transaction fees
                                                        </button>
                                                        </h6>
                                                        <div id="flush-collapseOne1" className="accordion-collapse collapse mt-3" data-bs-parent="#accordionFlushExample1">
                                                            <div className="accordion-body font8 p-0 mt-2 wthdrwtbl">
                                                            <table className="table table-bordered rounded-3">
                                                                <thead className="table-light">
                                                                    <tr>
                                                                    <th>#</th>
                                                                    <th>Min (KES)</th>
                                                                    <th>Max (KES)</th>
                                                                    <th>Charge ({getVendorCurrency()})</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {/* Transfers to M-PESA wallet */}
                                                                    <tr className="table-secondary">
                                                                    <th colSpan="5">Transfers to M-PESA</th>
                                                                    </tr>
                                                                    <tr>
                                                                    <td>1</td>
                                                                    <td>1</td>
                                                                    <td>1,500</td>
                                                                    <td>20</td>
                                                                    </tr>
                                                                    <tr>
                                                                    <td>2</td>
                                                                    <td>1,501</td>
                                                                    <td>20,000</td>
                                                                    <td>40</td>
                                                                    </tr>
                                                                    <tr>
                                                                    <td>3</td>
                                                                    <td>20,001</td>
                                                                    <td>Above</td>
                                                                    <td>60</td>
                                                                    </tr>

                                                                    {/* Transfers to Bank Account */}
                                                                    <tr className="table-secondary">
                                                                    <th colSpan="5">Transfers to Bank Account</th>
                                                                    </tr>
                                                                    <tr>
                                                                    <td>1</td>
                                                                    <td>1</td>
                                                                    <td>10,000</td>
                                                                    <td>80</td>
                                                                    </tr>
                                                                    <tr>
                                                                    <td>2</td>
                                                                    <td>10,001</td>
                                                                    <td>50,000</td>
                                                                    <td>120</td>
                                                                    </tr>
                                                                    <tr>
                                                                    <td>3</td>
                                                                    <td>50,001</td>
                                                                    <td>999,999</td>
                                                                    <td>140</td>
                                                                    </tr>
                                                                    <tr>
                                                                    <td>4</td>
                                                                    <td>1,000,001</td>
                                                                    <td>Above</td>
                                                                    <td>350</td>
                                                                    </tr>
                                                                </tbody>
                                                                </table>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                        </div></>}
                                        {pymtFormData0.acc_no == '0' && <>
                                            <button type="button" className="col-12 btn btn-success addpymt" data-bs-toggle="modal" data-bs-target="#addaccount"><Plus /> Update Payment Details</button>
                                        </>}
                                    </div>
                            </div>
                            <div className="col-12 col-lg-8 orderscontainer">                                
                                    <hr className="hddsktp0"></hr>
                                    <div className="mb-4">
                                        <h6 className="pageheader-title mb-3">Transactions History </h6>
                                        <div className="row mb-3">
                                            <div className="col-12"><input
                                                className="filter2 border me-2 w-100"
                                                type="search"
                                                placeholder="Search Transactions"
                                                aria-label="Search"
                                                onChange={(e) => setSearchTerm(e.target.value)} // Update the search term on keyup
                                            /></div>
                                        </div>
                                       
                                        
                                        
                                        {filteredResults.length === 0 ? (
                                            <p>No withdrawal records found.</p>
                                        ) : (
                                            filteredResults.map((item, index) => (                                                    
                                                        <div className="row ord-bg bg-white p-2 hvr bx-shadow" key={item.id}>
                                                            <div className="w-auto me-3 rownumsn p-0"><div className="pt-2 pl-2">{index+1}</div></div>
                                                            <div className="col-10 col-lg-11 pl-0 pr-0">
                                                                <div className="row">
                                                                    <div className="col-7 col-lg-3 ord-sz">#W{item.id}</div>
                                                                    <div className="col-5 col-lg-3 ord-sz text-primary">                                                                        
                                                                        <span className={`badge rounded-pill ${item.status === 'success' ? 'bg-success' : item.status === 'failed' ? 'bg-danger' : 'bg-warning'}`}>
                                                                            {item.status}
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-7 col-lg-4 ord-sz grey-text">{getVendorCurrency()} {item.amount}</div>
                                                                    <div className="col-5 col-lg-2 ord-sz grey-text">{formatDate(item.created_at)}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                            ))
                                        )}


                                    </div>
                            </div>
                        </div>

                        


                </div>
            </div>

            <div className="modal fade" id="withdrw" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog mt70">
                    <div className="modal-content">
                        <div className="modal-body pb-4"> 
                            {showSuccess === false && <>
                                     <div className="row">
                                        <div className="col-12"><p>Enter password to Withdraw <b>{getVendorCurrency()} {Intl.NumberFormat().format(amount)}</b></p></div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <input
                                                type="password"
                                                name="passver1"
                                                placeholder="•••••••"
                                                className="form-control text-center"
                                                style={{ fontFamily: 'monospace' }}
                                                value={pass}
                                                onChange={(e) => setPass(e.target.value)}
                                            />

                                        </div>
                                        <div className="col-12 mt-3">
                                            <button onClick={handleWithdraw} disabled={loading} className="btn btn-primary col-12">
                                                {loadingWithdraw ? 'Processing...' : 'Withdraw'}
                                            </button>
                                        </div>  
                                        {message0 && <div className="mt-3 text-danger font-bold font9 text-center">{message0}</div>}                                  
                                        {message && <div className="mt-3 text-success font-bold font9 text-center">{message}</div>}
                                    </div>
                            </>}  
                            {showSuccess === true && <>
                                    <div className="row text-center mt-4">
                                        <div className="col-md-12 mb-2">
                                            <div className="btn btn-outline-success border-0"><CheckCircle width='100px' height='100px' /></div>
                                        </div>
                                        <div className="col-12">
                                            <h2 className='mb-3 text-center'><b>Success</b></h2>
                                            <p className='grey-text mb-4'>Withdrawal request submitted successfully. Funds will be deposited shortly.</p>
                                        </div>
                                    </div>
                            </>}                                
                               
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="addaccount" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog mt70">
                    <div className="modal-content">
                        <div className="modal-body pb-4">                                  
                            <h6><b>Update Payment Details</b></h6>
                            <div className="mb-4">
                                <label htmlFor="lnm" className="form-label mb-0 font9">Account Type</label>
                                <div className="grey-text font9 mb-2">Select account type & account number</div>
                                <select className="form-control font9 ht40" onChange={inputHandler} name="pay_mode_desc">
                                    <option value="">Select</option>
                                    <option value="Mpesa">Mpesa</option>
                                    <option value="Bank">Bank</option>
                                </select>                                
                                {PayDiv1 && <p className='text-danger font9 p-0 m-0'>*Confirm this value</p>}
                                {pymtFormData.pay_mode_desc == "Bank" && <>
                                    <div className="grey-text font9 mt-3">Bank Name</div>
                                    <div className="input-group">
                                        <select
                                            className="form-control font9 ht40"
                                            name="pay_mode_desc_paybill"
                                            value={selectedBankIntasend}
                                            onChange={bankinputHandler}
                                        >
                                            <option value=""> { selectedBankIntasend != "" ? <>{selectedBankIntasend}</> : <>-- Select a Bank -- </>}</option>
                                            {banksIntasend.map((banksIntasend, index) => (
                                                <option
                                                key={index}
                                                value={`${banksIntasend.bank_name}  - ${banksIntasend.bank_code}`}
                                                >
                                                {banksIntasend.bank_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>     
                                    {PayDiv2 && <p className='text-danger font9 p-0 m-0'>*Confirm Paybill</p>}                           
                                 </>
                                }                                
                                <div className="grey-text font9 mt-3">{pymtFormData.pay_mode_desc == "Bank" && <>Account Number</>}{pymtFormData.pay_mode_desc == "Mpesa" && <>Mpesa No. 254 xxx xxx xxx</>}</div>
                                <div className="input-group">
                                    <input type="number" className="form-control font9 ht40" name="acc_no" onChange={inputHandler} placeholder=""/>
                                </div>
                                    {PayDiv3 && <p className='text-danger font9 p-0 m-0'>*Confirm this value</p>}
                                
                                <button type="button" className="col-12 btn btn-primary mt-4" onClick={submitHandler}>Complete</button>     
                                {PayDiv4 && <p className='text-success mt-4 text-center'><b>Account updated successfully</b></p>}
                            </div>
                            {pymtFormData0.acc_no != '0' && <>
                                <hr/>
                                <h6 className='font9'>Existing Payment Details</h6>
                                <div className="row ord-bg bg-white hvr bx-shadow font8 acc-con">      
                                    {pymtFormData0.pay_mode_desc == "Mpesa" && <>                                                 
                                        <div className="col-1">1</div> 
                                        <div className="col-4 p-0">{pymtFormData0.pay_mode_desc}</div>                                            
                                        <div className="col-5 p-0">{pymtFormData0.acc_no}</div>                                          
                                        <div className="col-2"><CheckCircle className="pointer text-success"/></div>                               
                                    </>
                                    }  
                                    {pymtFormData0.pay_mode_desc == "Bank" && <>                                                 
                                        <div className="col-1">1</div> 
                                        <div className="col-2 p-0">{pymtFormData0.pay_mode_desc}</div>                                            
                                        <div className="col-4 p-0">{pymtFormData0.pay_mode_desc_paybill}</div>                                             
                                        <div className="col-4 p-0">{pymtFormData0.acc_no}</div>                                          
                                        <div className="col-1 p-0"><CheckCircle className="pointer text-success"/></div>                               
                                    </>
                                    }                                      
                                    
                                </div>
                                </>
                            } 
                        </div>
                    </div>
                </div>
            </div>


        </section>
    )
}

export default SellerWithdraw;